import {useTimeContext} from 'hooks';
import {OffsetTime} from 'components';

export const CurrentTime = () => {
  const {localTime} = useTimeContext();
  return <OffsetTime date={localTime} />;
};
